import React, { Suspense, useEffect, useRef, useState } from 'react';

/**
 * Mounts `children` only once the placeholder comes within `rootMargin` of the viewport.
 * Use for heavy below-the-fold sections (and pair with React.lazy to split their code).
 */
const DeferredSection = ({ children, minHeight = 600, rootMargin = '600px 0px' }) => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(() => !('IntersectionObserver' in window));

    useEffect(() => {
        if (visible || !ref.current) return undefined;
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setVisible(true);
                observer.disconnect();
            }
        }, { rootMargin });
        observer.observe(ref.current);
        return () => observer.disconnect();
    }, [visible, rootMargin]);

    if (visible) {
        return <Suspense fallback={<div style={{ minHeight }} />}>{children}</Suspense>;
    }
    return <div ref={ref} style={{ minHeight }} />;
};

export default DeferredSection;
